// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"1c631960","632":"5b5f3f40","736":"ccfc4004","864":"bc0f49ee","912":"db10e018"}[chunkId] + ".chunk.js";
};